<template>
    <el-drawer
            :title="$t('Edit_subscription')"
            :before-close="closeHandle"
            v-if="mamSubAccountEditSubscrpitDialogShow"
            :visible="mamSubAccountEditSubscrpitDialogShow"
            direction="rtl"
            custom-class="copy-shell"
            :show-close="true"
            :close-on-press-escape="true"
            ref="drawer"
    >
        <div class="drawer-content">
            <el-scrollbar style="height: 100%;"> <!-- 滚动条 -->
                <div class="subscript-box pr">
                    <div class="mam">
                        <div class="first-step">
                            <div class="mam-title copytype-title">{{$t('Master_account_special')}}</div>
                            <div class="mam-info">
                                <div class="nickname">{{alias}}</div>
                                <div class="money-limit"
                                    v-if="moneyLimit"
                                >
                                    {{$t('Minimum_funding_limit')}} ${{moneyLimit}}
                                </div>
                            </div>
                            <el-form
                                    ref="mamform"
                                    :model="mamForm"
                                    :rules="mamRules"
                            >
                                <el-form-item prop="mamMt4">
                                    <p class="self-label">{{$t('MAM_Investment_Account')}}</p>
                                    <el-input disabled :value="mamSubEditSubscrpitParams.mamCopyLogin"></el-input>
                                    <p v-if="!mamSubEditSubscrpitParams.balance">
                                        <span class="font999">{{$t('User.moneyBanlanceNotEnough')}}</span>
                                        <span class="underline pointer" @click="depostHandel(1)">{{$t('Now_deposit')}}</span>
                                    </p>
                                    <template v-else>
                                        <p>
                                            <span class="font999">{{$t('available_balance')}}</span> {{mamSubEditSubscrpitParams.balance}}
                                        </p>
                                    </template>
                                </el-form-item>
                                <el-form-item prop="trusteeship">
                                    <p class="self-label">{{$t('Manage_funds')}}</p>
                                    <el-input
                                            :placeholder="phFileter($t('Please_enter_a_multiple_of_10'), self)"
                                            :value="mamForm.trusteeship"
                                            @input="trusteeshipInputHandle"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <p class="self-label">{{$t('User.payType')}}</p>
                                    <pay-way
                                      :management-fee="managementFee"
                                      :profots="profits"
                                    ></pay-way>
                                </el-form-item>
                                <el-form-item>
                                    <span>{{$t('management_fee')}}: {{managementCost || '-'}}</span>
                                </el-form-item>
                                <el-form-item>
                                    <p class="self-label">{{$t('The_account_to_pay_the_management_fee')}}</p>
                                    <el-input disabled :value="walletInfo.login"></el-input>
                                    <p v-if="enoughWalletBalance">
                                        <span class="">{{$t('available_balance')}}</span>
                                        <span class="master-moeny"> ${{walletInfo.balance}}</span>
                                    </p>
                                    <p v-else>
                                        <span>{{$t('Insufficient_available_balance')}},</span>
                                        <span class="btn-span pointer theme-font"
                                              @click="depostHandel(2)"
                                        >{{$t('Now_deposit')}}</span>
                                    </p>
                                </el-form-item>
                                <el-form-item>
                                    <el-checkbox
                                            v-model="mamForm.autoRenew"
                                    >{{$t('Automatic_renewal')}}</el-checkbox>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
            <div class="footer-box">
                <div
                        class="first-step-done"
                >
                    <div class="btn-box">
                        <el-button
                                class="next-btn step-btn"
                                type="primary"
                                @click="mamCopySubmitHandle"
                        >{{$t('User.saveSetting')}}</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import payWay from "@/components/common/mamSubscriptDialog/payWay";
    import { phFileter } from '@/utils/common';
    import { noZeroInit,amountInputValidate } from '@/utils/validate'
  import { queryMasterTraderInfo,checkCopyPassword,addSubscription, updateSubscription } from '@/api/copy.js'
  import { mapGetters } from 'vuex'
  import { queryAccountLimit,mtAccList } from '@/api/userCenter.js';
  export default {
    name: 'mamSubAccountEditSubscrpitDialog',
    components:{
      payWay
    },
    data() {
      let _this = this;
      var trusteeshipValidate = (rule, value, callback) => {
        if (((+value) % 10) == 0) {
          if(value > this.usableBalance){
            callback(new Error(_this.$t('The_funds_under_management_must_not_exceed_the_account_balance')));
          }else {
            callback();
          }
        } else {
          callback(new Error(_this.$t('Please_enter_a_multiple_of_10')));
        }
      };
      return {

        loading: false,
        alias: '',
        moneyLimit: '',
        passForm:{
          pass: '',
        },
        passRules:{
          pass: [
            {required: true, message: _this.$t('Please_enter_password'), trigger: 'blur'}
          ]
        },
        passwordPass: false,
        walletInfo: {
          login: '',
          balance: '',
        },
        mamForm:{
          trusteeship: '',
          autoRenew: false,
        },
        mamAccountList:[],
        mamRules:{
          trusteeship:[
            { required: true, message: _this.$t('Please_enter_managed_funds'), trigger: 'blur' },
            { validator: trusteeshipValidate,trigger: 'blur' }
          ],
        },
        managementFee: 0,
        self:{},
        profits:[]
      };
    },
    created(){
      this.self = this;
    },
    watch:{
      mamSubAccountEditSubscrpitDialogShow(newValue){
        if(newValue){
          this.passForm.pass = '';
          this.queryTraderInfo();
          this.queryMoneyAccount();
        }else {
          this.$store.commit('setMamSubEditSubscrpitParams', {
            trusteeship: '',
            mamMt4: '',
            autoRenew: false,
            ids: '',
          });
        }
      },
      mamSubEditSubscrpitParams(newValue){
        if(newValue.trusteeship){
          this.mamForm.trusteeship = newValue.trusteeship;
          this.mamForm.mamMt4 = newValue.mamMt4;
          this.mamForm.autoRenew = newValue.autoRenew;
        }
      }
    },
    computed: {
      ...mapGetters(['mamSubAccountEditSubscrpitDialogShow','userInfo','agreementFile','listRefresh','currentMasterMtId','mamSubEditSubscrpitParams',]),
      managementCost(){
        if((this.mamForm.trusteeship % 10) == 0){
          return this.mamForm.trusteeship * (parseFloat(this.managementFee) / 100);
        }else {
          return '-';
        }
      },
      enoughWalletBalance(){
        if(!noZeroInit(this.mamForm.trusteeship)){
          return true
        }else {
          if(this.walletInfo.balance > this.managementCost){
            return true;
          }else {
            return false;
          }
        }
      }
    },
    methods: {
      trusteeshipInputHandle(val){
        this.mamForm.trusteeship = amountInputValidate(val,'managedFund');
      },
      queryMoneyAccount(){
        mtAccList({
          id: this.userInfo.id,
          businessTypes: 3
        }).then((res) => {
          this.walletInfo = res.data[0];
        })
      },
      getProfitValue(item){
        return `≥${item.profitValue * 100}%`;
      },
      openAccountHandle(){
        queryAccountLimit({
          custId: this.userInfo.id,
        }).then((res) => {
          if(res.data === 0){
            this.$message({
              message: this.$t('Account_number_has_reached_maximum_limit'),
              type: 'warning'
            });
            return;
          }else {
            this.$store.commit('setOpenAccountDialogShow', true);
          }
        })
      },
      queryTraderInfo(){
        queryMasterTraderInfo({
          masterMtId: this.currentMasterMtId,
          isCreate: false,
        }).then((res) => {
          this.alias = res.data.content[0].alias;
          this.moneyLimit = res.data.content[0].subAmount;
          this.managementFee = res.data.content[0].price;
          if(res.data.profits && res.data.profits.length){
            this.profits = res.data.profits;
          }
        })
      },
      closeHandle() {
        this.$store.commit('setMamSubAccountEditSubscrpitDialogShow', false);
      },
      phFileter,
      depostHandel(number){
        let mastAccount = '';
        if(this.number == 1){
          mastAccount = this.mamSubEditSubscrpitParams.mamCopyLogin;
        }else {
          mastAccount = this.walletInfo.login;
        }
        this.$store.commit('setDepositAccount', mastAccount);
        this.closeHandle();
        this.$router.push({name: 'accessMoney'});
      },
      mamCopySubmitHandle(){
        let params = {
          ids: [this.mamSubEditSubscrpitParams.ids],
          isRenew: this.mamForm.autoRenew == true ? 1 : 0,
          managementAmount: this.mamForm.trusteeship,
        }
        this.loading = true;
        updateSubscription(params).then((res) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: this.$t('Edit_success')
          });
          setTimeout(() => {
            this.closeHandle();
            this.$store.commit('setListRefresh', !this.listRefresh)
          },1000);
        }).catch((error) => {
          this.loading = false;
        })
      }
    }
  };
</script>
<style lang="scss">
    .open-account-drawer  {
        .el-select{
            width: 100%;
        }
    }
</style>
<style lang="scss" scoped>
    @import "../../../../assets/scss/variable";
    .drawer-content {
        height: calc(100vh - 64px - 100px);
        &.need-pass {
            height: calc(100vh - 64px);
        }
        border-top: 1px solid #E6E6E6;
    }
    .footer-box {
        padding: 10px 20px;
    }

    .subscript-box {
        padding: 20px;
        .copytype-title {
            margin-bottom: 5px;
        }
        .mam-info {
            background-color: #F6F8FA;
            padding: 15px;
            margin-bottom: 25px;
            .nickname {
                font-size: 14px;
                color: #333333;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .money-limit {
                color: #999999;
            }
        }
        .second-step {
            .second-step-title {
                color: #333333;
                font-size: 14px;
                margin-bottom: 20px;
            }
            .info-box {
                margin-top: 20px;
                font-size: 14px;
                color: #333333;
                .info-line {
                    margin-bottom: 18px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .info-line-border {
                        flex: 1;
                        border-bottom: 1px solid #999999;
                    }
                    .info-line-text {
                        margin-right: 5px;
                    }
                    .info-line-data {
                        margin-left: 5px;
                    }
                }
            }
        }
    }
    .pay-way {
        border-radius: 5px;
        border: 1px solid #c5c5c5;
        padding: 15px 20px;
        line-height: 40px;
        .line-box {
            height: 28px;
            line-height: 28px;
            padding: 0 10px;
            &.odd-box {
                background-color: #F9FAFB;
            }
        }
    }
    .step-btn {
        width: 100%;
    }
    .next-btn {
        margin-top: 20px;
    }
    .prev-btn {
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
    }
    .need-pass {
        width: 100%;
        height: 100%;
        z-index: 99;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, .9);
        padding: 50px 30px;

        .title {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
        }

        .pass-submit-btn {
            width: 100%;
        }
    }
</style>
